module.exports = __webpack_public_path__ + "static/media/spin_wheel_center.193e953d.png";